import React from "react";
import { Route } from "react-router-dom";
import Approval from "../../../containers/modules/log/approval";

export default function ApprovalRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="approval"
      index
      element={
        <Approval
        />
      }
    />
  );
}
